const Platforms = {
    IOS:'IOS',
    ANDROID:'ANDROID',
    WEB:'WEB',
    MOBILE_WEB:'MOBILE_WEB'
}

export default Platforms;